
import store from '@/store/index'
import CommentsRes from '@/components/Aio/star3/CommentsRes.vue'
import NoteProgress from '@/components/Aio/star3/NoteProgress.vue'
import { registerFnHandler } from '@/utils/registerFnHandler'
import { getVersionInfo } from "@/api/aio";
import { computed, inject, onMounted, watch } from "vue";
import { nativeToast, playVideo, doJump, getClientCommonMessage,takeResources, previewResources } from "@/utils/nativeFn";
import { queryVideoInfo, getNoteInfo} from "@/api/aio";
import { useRouter } from "vue-router";
import QuestionDetail from "@/components/Aio/QuestionTile.vue";
import AioConfirm from "@/components/Aio/AioConfirm.vue";
import { compareVersion } from "@/utils/compareVersion";
import { ref, reactive } from "vue";
import { isIOS } from "@/assets/js/utils";
import BeforeUpload from "../../components/Aio/star3/BeforeUpload.vue"
import NoteStrategy from "../../components/Aio/star3/NoteStrategy.vue"
import CardInfoMyNote from "./CardInfoMyNote.vue"
export default {
  name: "TaskList",
  components: {
    AioConfirm,
    BeforeUpload,
    CardInfoMyNote,
    NoteStrategy,
    NoteProgress,
    CommentsRes
  },
  props: {
    skuId: {
      type: String,
      default: "",
    },
    cardName: {
      type: String,
      default: "",
    },
    cardType: {
      type: Number,
      default: 0,
    },
    unionid: {
      type: String,
      default: "",
    },
    taskList: {
      type: Array,
      default: () => [],
    },
    reportDataMap: {
      type: Object,
      default: () => ({}),
    },
    difficulty: {
      type: Number,
      default: 0,
    },
    parentInfo: {
      type: Object,
      default: () => ({} as { action: number; progress: number; }),
    }
  },
  emits: ["setTheDoingTaskObj"],
  setup(props, { emit }) {
    const router = useRouter();
    const $xesLog = inject("$xesLog") as any; // 埋点
    let clickedVideoPlay = false;
    const confirmVisible = ref(false);
    const app_version = ref("0");
    const confirmInfo = reactive({});
    const downloadUrl = ref("");
    const progress = ref(0);
    const parentInfo = computed(() => {
      if (props.parentInfo.progress === 0 && progress.value === 1) {
        return { ...props.parentInfo, progress: 1 }
      }
      return props.parentInfo 
    })
    const reportDataMap = { ...props.reportDataMap }
    // 三星卡牌笔记部分
    const strategyFirstShow = ref(false) // 是否第一次展示三星卡牌推荐策略 
    const strategyVisible = ref(false) // 是否展示推荐策略
    const callUploadActionVisible = ref(false)
    const callUploadActions = [
        { name: '拍照', type: 'camera' },
        { name: '从相册选择', type: 'library', className: 'actionSheetItem' },
    ]
    let commentInfo = ref({})
    let versionName = ref(0)
    let progressList = computed(()=>{
      if(parentInfo.value.progress === 1){
        return [
          {
            desc: '上传笔记',
            status: 'done'
          },
          {
            desc: '笔记批改',
            status: 'pendding'
          },
          {
            desc: '批改完成',
            status: 'todo'
          }
        ]
      }else if(parentInfo.value.progress === 2){
                        return [
              {
                desc: '上传笔记',
                status: 'done'
              },
              {
                desc: '笔记批改',
                status: 'done'
              },
              {
                desc: '未通过',
                status: 'fail'
              },
          ]
        
      }else if(parentInfo.value.progress === 3) {
return []
      }
    })

    //审核图片列表 
    const notePicList = ref([])
    const noteInfo = ref({})
    const maxUpLoadNum = computed(()=>store.getters['star3Note/max_upload_num'])
    const getContent = () => {
      if (parentInfo.value.action === 5 && ((parentInfo.value.progress || 0) > 0 || (localStorage.getItem('lastPagePath') === '/note-page-3star' && localStorage.getItem('firstUploadNoteSuccess') === '1'))) {
        // 任务类型是图片审核 通过任务id获取笔记详情 props.parentInfo.
        getNoteInfo({ unicode: props.parentInfo.uuid })
        .then(res => {
          if (res.data?.code === 0) {
            commentInfo.value = res.data.data
            notePicList.value = res.data.data.resource || []
            if (notePicList.value.length && parentInfo.value.progress === 0) {
              progress.value = 1
            }
          } else {
            notePicList.value = []
          }
          setNoteList(notePicList.value)
        }).catch(err => {
          // nativeToast('笔记资源加载失败')
          setNoteList([])
        })
      }
    }
    watch(parentInfo,(val)=>{
      getContent()
    })
    //组装笔记数据
    const setNoteList = (data) => {
      const sourceList = data.map(item => ({
        resource: item.resource_url,
        type: 'urlStr'
      }))
      store.commit("SET_STAR3_NOTELIST", ["star3NoteList", sourceList]);
    }
    // 任务条点击
    const onClickTaskTile = (item) => {
      if (!item.btnEnable) {
        nativeToast("更多任务升级中，敬请期待", 1);
      }
    };
    // 任务按钮点击
    const onClickBtn = (item) => {
      // console.log(item,'任务信息')
      if (item.btnEnable && !clickedVideoPlay) {
        console.log("任务按钮点击");
        clickedVideoPlay = true;
        emit("setTheDoingTaskObj", {
          pUuid: item.pUuid,
          uuid: item.uuid,
          resourceType: item.resource_type,
        });
        if (item.resource_type === 1) {
          // 视频
          queryVideoInfo({ unionid: item.resource })
            .then((res) => {
              if (res.data.code == 0) {
                const params = {
                    resource_vod_src: res.data.data.resource_vod_src,
                    resource_src: res.data.data.resource_src,
                    skuId: props.skuId,
                    cardId: props?.unionid,
                    taskStatus: item.finish_status,
                    taskUuid: item.uuid,
                    taskPUuid: item.pUuid,
                    content_id: item.resource,
                    sn: res.data.data.sn || '',
                    source_list: res.data.data.source_list || [],
                    is_dot: res.data.data.is_dot,
                    title: res.data.data.title
                };
                // console.log(JSON.stringify(params), '传给端参数')
                let timer = setTimeout(() => {
                  clickedVideoPlay = false;
                  clearTimeout(timer);
                }, 300);
                // 视频
                playVideo(params, (res) => {
                  console.log("视频播放中");
                  clickedVideoPlay = false;
                });
              } else if (res.data.code == 100210) {
                clickedVideoPlay = false;
                nativeToast(res.data.message);
              } else {
                clickedVideoPlay = false;
                nativeToast(res.data.message ? res.data.message : "获取视频地址失败");
              }
            })
            .catch((err) => {
              clickedVideoPlay = false;
              nativeToast("网络连接失败，请稍后再试～");
            });

          // 知识点任务按钮点击埋点
          $xesLog.track("button_click", {
            ...reportDataMap,
            card_name: props.cardName || "",
            task_title: item.title,
            button_name: "knowledge_card_task_button",
            button_status: item.difficulty,
            task_status: item.finish_status ? 1 : 2,
            task_card_type:props?.cardType === 1 ? '无星' : '3星'
          });
        } else if (item.resource_type === 4) {
            // 跳转试卷答题
            router.push({
              path: "/task-paper",
              query: {
                paperId: item.resource,
                source_location: "card_tasks",
              },
            });
            clickedVideoPlay = false;
        } else {
          clickedVideoPlay = false;
          nativeToast("任务类型暂不能受理");
        }
      }
    };
    // 获取版本号
    const getAppVersion = () => {
      getClientCommonMessage({}, (res) => {
        // console.log("h5调用端上getClientCommonMessage", res); // app返回给前端的值
        app_version.value = res.service_version_name || "0.0.0";
      });
    };
    const getVersion = () => {
      getVersionInfo().then((res) => {
        if (res.data.code !== 0) {
          return;
        }
        if (!isIOS()) {
          downloadUrl.value = res.data.data.update.file_path_url;
        } else {
          downloadUrl.value = res.data.data.update.itunes_url;
        }
      });
    };
    const doClose = () => {
      confirmVisible.value = false;
    };
    const doConfirm = () => {
        doJumpFn()
      confirmVisible.value = false;
    };
    const doJumpFn = () => {
      let path = `10001?parameters=${encodeURIComponent(
        JSON.stringify({
          url: downloadUrl.value,
        })
      )}`;
      doJump(path, () => {
        console.log("跳转成功");
      });
    };
    const showStrategy = () => {
            strategyFirstShow.value = localStorage.getItem('strategyFirstShow') !== '1'
            localStorage.setItem('strategyFirstShow', '1')
            strategyVisible.value = true
            $xesLog.view("notes_intro_popup_show", {
              ...reportDataMap,
              is_first_time: strategyFirstShow.value ? '首次' : '非首次',
              event_name: '笔记攻略弹窗曝光'
            });
        }
        // 上传方式调起来源
        let callUploadActionSource = ''
        // 调起上传actionsheet
        const callUploadAction = () => {
          console.log(compareVersion(app_version.value + '',app_version.value),"1.11.0",'compareVersion')
          if(compareVersion(app_version.value + '',"1.11.0") == -1){
            console.log('不支持卡牌')
            openUpgradeModal()
          }else{
            callUploadActionSource = strategyVisible.value ? '笔记攻略弹窗' : '知识点详情页上传按钮'
            strategyVisible.value = false
            callUploadActionVisible.value = true
            // 上传笔记方式弹窗曝光
            $xesLog.track("notes_upload_choose_popup_show", {
              ...reportDataMap,
              event_name: '上传笔记方式弹窗曝光'
            });
          }
        }
        const openUpgradeModal = () => {
            Object.assign(confirmInfo, {
                title: 'app升级提示',
                titleArr:['本版本暂不支持该题型，请先升级～','方式1: 应用商店搜索最新版本更新','方式2: app内点击【我的】->【关于我们】->【当前版本】更新'],
                confirmText: '确定',
                doConfirm:doConfirmFn,
            })
            confirmVisible.value = true
        }
        const doConfirmFn = () => {
            confirmVisible.value = false
        }
        let selectUploadActionItem = ''
        // 处理上传actionsheet的选中
        const handleSelectUploadAction = (item) => {

            setNoteList(notePicList.value)
            selectUploadActionItem = item.name
            callUploadActionVisible.value = false
            // console.log(maxUpLoadNum.value[parentInfo.value.card_id] - noteList.length,'maxCount')
            takeResources({
                type: item.type,
                maxCount: (maxUpLoadNum.value[parentInfo.value.card_id + ''] || 6) - (store.getters.star3NoteList?.length || 0),
                sourceType: 'image',
                from: 'star3'
            })
            $xesLog.track("notes_upload_choose_button_click", {
              ...reportDataMap,
              card_name: props.cardName || "",
              task_card_type:props?.cardType === 1 ? '无星' : '3星',
              button_name: item.name || '',
              popup_location: callUploadActionSource || '知识点详情页上传按钮',
              event_name: '上传笔记方式弹窗点击'
            });
        }
        const handleUploadActionCancel = () => {
          $xesLog.track("notes_upload_choose_button_click", {
            ...reportDataMap,
            card_name: props.cardName || "",
            task_card_type:props?.cardType === 1 ? '无星' : '3星',
            button_name: '取消',
            popup_location: callUploadActionSource || '知识点详情页上传按钮',
            event_name: '上传笔记方式弹窗点击'
          });
        }
        // 端上回传图片列表
        const takeResourcesCallback = (data) => {
          console.log('===选择的资源信息====0', JSON.stringify(data))
          data = data.map(item=> {
            return {
              ...item,
              base64: `data:image/gif;base64,${item.resource}`,
              type: 'uriStr'
            }
          })
          store.commit('SET_STAR3_NOTELIST', ['star3NoteList',data])
          // 跳转笔记页
          router.push({
            path: "/note-page-3star",
            query: {
                column_id: props.parentInfo.column_id,
                card_id: props.parentInfo.card_id,
                unicode:props.parentInfo.uuid,
                progress:props.parentInfo.progress,
                ...reportDataMap,
                cardType: props?.cardType,
                source_location: selectUploadActionItem
              }
          });
        }
        // 删除笔记成功 修改 parentInfo.progress
        const noteDeleteDone = () => {
          notePicList.value = []
          store.commit("SET_STAR3_NOTELIST", ["star3NoteList", []]);
          parentInfo.value.progress = 0
        }
        const resetStar3NoteList = () => {
          setNoteList(notePicList.value)
        }

    onMounted(() => {
      // console.log(props.parentInfo,'parentInfo1111')
      // setProgress()
      // 注册选择图片的回调
      registerFnHandler('takeResourcesCallback', (res) => {
          const { from = '', data = '[]', sourceType = ''  } = res || {}
          try {
            takeResourcesCallback(typeof data === "string" ? JSON.parse(data) : data);
          }catch(err) {
            console.log(err)
          }
      })
      getAppVersion();
      getVersion();
      getContent()
    });
    return {
      onClickBtn,
      onClickTaskTile,
      confirmVisible,
      confirmInfo,
      parentInfo,
      showStrategy,
      callUploadAction,
      handleSelectUploadAction,
      handleUploadActionCancel,
      strategyVisible,
      callUploadActions,
      callUploadActionVisible,
      progressList,
      strategyFirstShow,
      notePicList,
      commentInfo,
      noteDeleteDone,
      maxUpLoadNum,
      reportDataMap,
      resetStar3NoteList,
      openUpgradeModal
    };
  },
};
